import memoize from 'transmute/memoize';
import { getDisabledFeatureContextMessage } from 'automation-ui-permissions/feature-permissions/constants/DisabledFeatureContextMessages';
import { getDisabledFeatureMessage } from 'automation-ui-permissions/feature-permissions/constants/DisabledFeatureMessages';
import { EMBED_FEATURE_PERMISSIONS_FIELD_NAME, FEATURE_PERMISSIONS_BY_FLOW_ID_FIELD_NAME, FEATURE_PERMISSIONS_FIELD_NAME } from 'automation-ui-permissions/feature-permissions/queries/featurePermissionsQueries';
import FeaturePermission from 'automation-ui-permissions/feature-permissions/records/FeaturePermission';
import FeaturePermissions from 'automation-ui-permissions/feature-permissions/records/FeaturePermissions';
import { formatFeaturePermissionsBySourceApp } from 'automation-ui-permissions/feature-permissions/utils/formatFeaturePermissionsBySourceApp';
export const defaultFeaturePermission = new FeaturePermission({
  access: false,
  reason: null
});
export const getFeaturePermissionForSourceApp = memoize((featurePermissions, feature, sourceApp) => {
  if (featurePermissions && sourceApp) {
    const sourceAppFeaturePermissions = featurePermissions.get(sourceApp);
    if (sourceAppFeaturePermissions) {
      return sourceAppFeaturePermissions.getFeaturePermission(feature);
    }
  }
  return defaultFeaturePermission;
}, (featurePermissions, feature, sourceApp) => `${featurePermissions ? featurePermissions.size : 0}-${sourceApp}-${feature}`);
export const getFeaturePermissionFromQuery = (featurePermissionsQuery, feature, sourceApp, featureContext) => {
  const {
    data: {
      [FEATURE_PERMISSIONS_FIELD_NAME]: featurePermissions = formatFeaturePermissionsBySourceApp([])
    } = {}
  } = featurePermissionsQuery;
  const featurePermission = getFeaturePermissionForSourceApp(featurePermissions, feature, sourceApp);
  const disabledReason = featurePermission.getReason();
  return {
    disabledFeatureMessage: featureContext ? getDisabledFeatureContextMessage({
      feature: feature,
      disabledReason,
      featureContext
    }) : getDisabledFeatureMessage({
      feature,
      disabledReason
    }),
    hasFeatureAccess: featurePermission.getHasAccess(),
    query: featurePermissionsQuery,
    disabledReason
  };
};
export const getFlowFeaturePermissionFromQuery = (featurePermissionsByFlowIdQuery, feature) => {
  const {
    data: {
      [FEATURE_PERMISSIONS_BY_FLOW_ID_FIELD_NAME]: featurePermissions = new FeaturePermissions({})
    } = {}
  } = featurePermissionsByFlowIdQuery;
  const featurePermission = featurePermissions.getFeaturePermission(feature) || defaultFeaturePermission;
  const disabledReason = featurePermission.getReason();
  return {
    disabledFeatureMessage: getDisabledFeatureMessage({
      feature,
      disabledReason
    }),
    hasFeatureAccess: featurePermission.getHasAccess(),
    query: featurePermissionsByFlowIdQuery,
    disabledReason
  };
};
export const getEmbedFlowFeaturePermissionFromQuery = (embedFeaturePermissionsQuery, feature) => {
  const {
    data: {
      [EMBED_FEATURE_PERMISSIONS_FIELD_NAME]: featurePermissions = new FeaturePermissions({})
    } = {}
  } = embedFeaturePermissionsQuery;
  const featurePermission = featurePermissions.getFeaturePermission(feature) || defaultFeaturePermission;
  const disabledReason = featurePermission.getReason();
  return {
    disabledFeatureMessage: getDisabledFeatureMessage({
      feature,
      disabledReason
    }),
    hasFeatureAccess: featurePermission.getHasAccess(),
    query: embedFeaturePermissionsQuery,
    disabledReason
  };
};
export const getFeaturePermissionAndQuery = (featurePermissionsQuery, featurePermissionsByFlowIdQuery, embedFeaturePermissionsQuery, flowId, isEmbedded, feature, sourceApp, featureContext) => {
  if (isEmbedded) {
    return getEmbedFlowFeaturePermissionFromQuery(embedFeaturePermissionsQuery, feature);
  }
  if (flowId) {
    return getFlowFeaturePermissionFromQuery(featurePermissionsByFlowIdQuery, feature);
  }
  return getFeaturePermissionFromQuery(featurePermissionsQuery, feature, sourceApp, featureContext);
};